import { render, staticRenderFns } from "./kontakt.vue?vue&type=template&id=84f8c188&scoped=true&"
import script from "./kontakt.vue?vue&type=script&lang=js&"
export * from "./kontakt.vue?vue&type=script&lang=js&"
import style0 from "./kontakt.vue?vue&type=style&index=0&id=84f8c188&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f8c188",
  null
  
)

export default component.exports